import CompanyProfileDto from '@/models/Companies/CompanyProfileDto';
import LocationProfileDto from '@/models/Locations/LocationProfileDto';
import BranchDto from '@/models/Branches/BranchDto';
import DeskDto from '@/models/Desks/DeskDto';
import DateTimeUtils from '@/lib/dateTimeUtils';
import WorkerProfileDto from '@/models/Workers/WorkerProfileDto';
import JobProfileDto from '@/models/Jobs/JobProfileDto';

export default class CurrentJobScheduleSearchCriteria {
    from: string = DateTimeUtils.getThisMondayAsIso();
    //to: string = DateTimeUtils.toDDMMYY(new Date());
    selectedCompany: CompanyProfileDto;
    selectedLocation: LocationProfileDto;
    selectedDesk: DeskDto;
    selectedBranch: BranchDto;
    selectedWorker: WorkerProfileDto;
    selectedJob: JobProfileDto;
}